<template>
    <div>
        <a-row type="flex" justify="center" >
            <vxe-button size="mini" status="primary" @click="print()">
                打印
            </vxe-button>
        </a-row>
        <a-row ref="printArea" type="flex" justify="center" align="middle" style="padding-top: 100px">
            <table border="1" cellspacing="0" cellpadding="0">
                <tr>
                    <th colspan="7" class="table-name">客户信息档案表</th>
                </tr>
                <tr>
                    <th rowspan="3" class="td3">车辆信息</th>
                    <td colspan="1" class="td1">品系</td>
                    <td colspan="2" class="td2">{{entityForm.strainName}}</td>
                    <td colspan="1" class="td1">购车时间</td>
                    <td colspan="2" class="td2">{{entityForm.e3sDeliveryDate}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">底盘号</td>
                    <td colspan="2" class="td2">{{entityForm.batholithNo}}</td>
                    <td colspan="1" class="td1">车型代码</td>
                    <td colspan="2" class="td2">{{entityForm.modelCode}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">所属经理部</td>
                    <td colspan="2" class="td2">{{entityForm.regionName}}</td>
                    <td colspan="1" class="td1">经销商</td>
                    <td colspan="2" class="td2">{{entityForm.dealerName}}</td>
                </tr>
                <tr>
                    <th rowspan="7" class="td3">客户信息</th>
                    <td colspan="1" class="td1">姓名</td>
                    <td colspan="2" class="td2">{{entityForm.custName}}</td>
                    <td colspan="1" class="td1">性别</td>
                    <td colspan="2" class="td2">{{entityForm.sexName}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">电话</td>
                    <td colspan="2" class="td2">{{entityForm.mobile}}</td>
                    <td colspan="1" class="td1">民族</td>
                    <td colspan="2" class="td2">{{entityForm.nationName}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">身份证</td>
                    <td colspan="2" class="td2">{{entityForm.idCard}}</td>
                    <td colspan="1" class="td1">出生日期</td>
                    <td colspan="2" class="td2">{{entityForm.birthday}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">行业</td>
                    <td colspan="2" class="td2">{{entityForm.industryName}}</td>
                    <td colspan="1" class="td1">客户类型</td>
                    <td colspan="2" class="td2">{{entityForm.custCategoryName}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">是否乘龙老友</td>
                    <td colspan="2" class="td2">{{entityForm.isOldFriendName}}</td>
                    <td colspan="1" class="td1">职位</td>
                    <td colspan="2" class="td2"></td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">省份</td>
                    <td colspan="2" class="td2">{{entityForm.provinceName}}</td>
                    <td colspan="1" class="td1">市</td>
                    <td colspan="2" class="td2">{{entityForm.cityName}}</td>
                </tr>
                <tr>
                    <td colspan="1" class="td1">区</td>
                    <td colspan="2" class="td2">{{entityForm.districtName}}</td>
                    <td colspan="1" class="td1">详细地址</td>
                    <td colspan="2" class="td2" style="text-align: left;padding-left:10px;">{{entityForm.address}}</td>
                </tr>
            </table>
        </a-row>
    </div>
</template>

<script>
    import {dataApi} from '@/services/client/maintainCust';


    export default {
        props: ['vehicleId'],
        data() {
            return {
                entityForm:{}
            }
        },
        async mounted() {
            let entity = await dataApi.getFormDetail(this.vehicleId);
            console.log("打印,",entity)
            this.entityForm = entity.data
        },
        methods: {
            print(){
                this.$print(this.$refs.printArea)
            }
        }
    }
</script>

<style scoped>
table {
    border-collapse: collapse;
    width: 710px;
    table-layout: fixed;
}
.table-name {
    height: 60px;
    width:  710px;
    vertical-align: middle;
    text-align: center;
    font-size: 24px;
    color: #333;
}
.td1{
    width: 60px;
    height: 60px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
.td2{
    height: 60px;
    width: 100px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
.td3{
    width: 80px;
    height: 60px;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    color: #333;
}
</style>
